"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeCheckin_en_us = void 0;
function backofficeCheckin_en_us() {
    return {
        "backoffice.checkin.title": "Check-in",
        "backoffice.checkin.visitors.title": "Visitors",
        "backoffice.checkin.visitors.subtitle": "Create new visitors or manage their data",
        "backoffice.checkin.visitors.tabheader": "Visitors",
        "backoffice.checkin.visitors.form": "Form",
        "backoffice.checkin.visitors.formdeleted": "Form deleted",
        "backoffice.checkin.visitors.fields": "Fields",
        "backoffice.checkin.visitors.visitor": "Visitor",
        "backoffice.checkin.visitors.contactperson": "Contact Person",
        "backoffice.checkin.visitors.documents": "Documents",
        "backoffice.checkin.visitors.deleteon.label": "Removal Date",
        "backoffice.checkin.visitors.deleteon.description": "The date, the user wants us to delete all of their data",
        "backoffice.checkin.visitors.buttons.create": "Create",
        "backoffice.checkin.visitors.buttons.remove": "Delete",
        "backoffice.checkin.visitors.buttons.signin": "Sign In",
        "backoffice.checkin.visitors.buttons.signout": "Sign Out",
        "backoffice.checkin.visitors.buttons.export": "Export",
        "backoffice.checkin.visitors.buttons.import": "Import",
        "backoffice.checkin.visitors.buttons.sendemail": "Send Visitor Pass via Mail",
        "backoffice.checkin.visitors.visits.status": "Status",
        "backoffice.checkin.visitors.visits.in": "Login",
        "backoffice.checkin.visitors.visits.out": "Logout",
        "backoffice.checkin.visitors.visits.online": "Logged in",
        "backoffice.checkin.visitors.visits.offline": "Logged out",
        "backoffice.checkin.visitors.visits.recent": "Last visit",
        "backoffice.checkin.visitors.visits.events": "Status",
        "backoffice.checkin.visitors.empty.title": "We're waiting for your first visitors...",
        "backoffice.checkin.visitors.empty.meanwhile": "In the meantime you can create new forms, create contact persons, generate apps and create and invite new visitors.",
        "backoffice.checkin.visitors.empty.createapp": "Check-in Apps",
        "backoffice.checkin.visitors.empty.createform": "Forms",
        "backoffice.checkin.visitors.empty.createcontactperson": "Contact persons",
        "backoffice.checkin.visitors.nocheckinappmsg": "You have not yet set up a check-in app.",
        "backoffice.checkin.visitors.appointments.create.title": "Create Appointment",
        "backoffice.checkin.visitors.appointments.create.description": "",
        "backoffice.checkin.visitors.appointments.create.success": "Appointment was created successfully",
        "backoffice.checkin.visitors.appointments.create.successwithmail": "Appointment was created successfully. An email has been sent.",
        "backoffice.checkin.events.tabheader": "Events",
        "backoffice.checkin.events.title": "Events",
        "backoffice.checkin.events.subtitle": "Whenever a visitor does something like coming in, signing out etc., we'll create an event",
        "backoffice.checkin.events.in": "Sign-In",
        "backoffice.checkin.events.out": "Sign-Out",
        "backoffice.checkin.events.status.in": "signed in at",
        "backoffice.checkin.events.status.out": "signed off at",
        "backoffice.checkin.apps.title": "Check-In Apps",
        "backoffice.checkin.apps.subtitle": "Create and manage web apps over which your visitors can sign-in",
        "backoffice.checkin.apps.tabheader": "Apps",
        "backoffice.checkin.apps.empty.title": "No Apps found...",
        "backoffice.checkin.apps.empty.meanwhile": "In the meantime you can create your own and individual apps here.",
        "backoffice.checkin.apps.empty.createapp": "Create a new App",
        "backoffice.checkin.devices.launchconfirmdialogtitle": "Launch app on Device",
        "backoffice.checkin.devices.launchconfirmdialogmessage": "Do you really want to launch this app on the device ${device}?",
        "backoffice.checkin.contactpersons.title": "Contact persons",
        "backoffice.checkin.contactpersons.subtitle": "Manage contact persons which can be referenced from your checkin app",
        "backoffice.checkin.contactpersons.tabheader": "Contact persons",
        "backoffice.checkin.contactpersons.empty.title": "No contact person found...",
        "backoffice.checkin.contactpersons.empty.meanwhile": "You can apply as many contact persons as you like. They will show up in forms for your visitor to select one.",
        "backoffice.checkin.contactpersons.empty.createapp": "New contact person",
        "backoffice.checkin.contactpersons.empty.createform": "Check-in Form",
        "backoffice.checkin.contactpersons.empty.createcontactperson": "Add a new contact person",
        "backoffice.checkin.printerconfigurations.new": "Create",
        "backoffice.checkin.printerconfigurations.title": "Printer Configurations",
        "backoffice.checkin.printerconfigurations.subtitle": "Manage configurations for printers which you are using in connection with your check-in apps",
        "backoffice.checkin.printerconfigurations.tabheader": "Printer Configurations",
        "backoffice.checkin.printerconfigurations.empty.title": "No printer configurations found...",
        "backoffice.checkin.printerconfigurations.empty.meanwhile": "Here you can create and edit printer configurations. They will show up in this table as column per created form.",
        "backoffice.checkin.printerconfigurations.empty.creationtitle": "New printer configurations",
        "backoffice.checkin.workflows.events.signin.label": "Check-in App: Visitor signs in",
        "backoffice.checkin.workflows.events.signin.description": "This event will get triggered whenever a visitor signs in",
        "backoffice.checkin.workflows.events.signout.label": "Check-in App: Visitor signs out",
        "backoffice.checkin.workflows.events.signout.description": "This event will get triggered whenever a visitor signs out",
        "backoffice.checkin.workflows.events.event.label": "Check-in App: Visitor Action",
        "backoffice.checkin.workflows.events.event.description": "This event will get fired whenever a visitor triggers an action like sign in or sign out"
    };
}
exports.backofficeCheckin_en_us = backofficeCheckin_en_us;
